import React from 'react';
import { ConfigurationContext } from './configuration.context';
import { useAuthContext } from '@isyc-react/auth/modules/context';
import { useBailleursConfigurationQuery } from 'common/api';
export const ConfigurationProvider = props => {
    const { children } = props;
    const { user } = useAuthContext();
    const [configuration, setConfiguration] = React.useState(null);
    const { data, loading, error } = useBailleursConfigurationQuery();
    React.useEffect(() => {
        if (data && data.data) {
            setConfiguration(data.data);
        }
    }, [data]);
    return (React.createElement(ConfigurationContext.Provider, { value: {
            configuration,
            error: Boolean(error),
            loading,
        } }, children));
};
